import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router } from '@angular/router';
import { AuthorizationService } from '@core/authorization/services/authorization.service';
import { Location } from '@angular/common';
import { DeepLinkFacade } from '@core/deep-link/store/facade/deep-link.facade';
import { ApplicationPath } from '@core/navigation/models/application-path.enum';

export const isAuthorizedUserGuard: CanActivateFn & CanMatchFn = () => {
  const authorizationService = inject(AuthorizationService);
  const router = inject(Router);
  const location = inject(Location);
  const deepLinkFacade = inject(DeepLinkFacade);

  if (authorizationService.isAuthorized()) {
    return true;
  }

  deepLinkFacade.setDeepLink(location.path());
  router.navigateByUrl(ApplicationPath.Login);
  return false;
};
